import { combineReducers } from 'redux';
import postReducer from './posts/postReducer';
import applicationReducer from './application/applicationReducer';
import saleorderReducer from './saleorder/saleorderReducer';
import projectReducer from './project/projectReducer';
import productReducer from './product/productReducer';
import customerReducer from './customer/customerReducer';
import saleordersReducer from './saleorders/saleordersReducer';
import projectsviewReducer from './projectsview/projectsviewReducer';
import walletReducer from './wallet/walletReducer';
import partyReducer from './party/partyReducer';
import disbursementRequestReducer from './disbursementrequest/disbursementrequestReducer';
import personReducer from './person/personReducer';
import unlockrequestReducer from './unlockrequest/unlockrequestReducer';

import { USER_LOGOUT } from 'reducers/constants';
import affiliateReducer from "./affiliate/affiliateReducer";

const appReducer = combineReducers({
    application: applicationReducer,
    posts: postReducer,
    saleorder: saleorderReducer,
    project: projectReducer,
    product: productReducer,
    customer: customerReducer,
    affiliate: affiliateReducer,
    saleorders: saleordersReducer,
    projectsview: projectsviewReducer,
    account: walletReducer,
    party: partyReducer,
    disbursementrequest: disbursementRequestReducer,
    person: personReducer,
    unlockRequest: unlockrequestReducer
});

const rootReducer = (state, action) => {
    if (action.type === USER_LOGOUT) {
        state = undefined
    }

    return appReducer(state, action)
}

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js